<template>
  <v-container fluid grid-list-xl>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <v-text-field
              :label="labels.uuid"
              v-model="campus.uuid"
              @click:append="editarCampus('uuid')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.nombre"
              v-model="campus.nombre"
              @click:append="editarCampus('nombre')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.entidad_federativa"
              v-model="campus.entidad_federativa.nombre"
              @click:append="editarCampus('entidad_federativa')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.ciudad"
              v-model="campus.ciudad"
              @click:append="editarCampus('ciudad')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.institucion"
              v-model="campus.institucion"
              @click:append="editarCampus('institucion')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.clave_estatal"
              v-model="campus.clave_estatal"
              @click:append="editarCampus('clave_estatal')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.clave_federal"
              v-model="campus.clave_federal"
              @click:append="editarCampus('clave_federal')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.clave_pago"
              v-model="campus.clave_pago"
              @click:append="editarCampus('clave_pago')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.consecutivo_titulos"
              v-model="campus.consecutivo_titulos"
              @click:append="editarCampus('consecutivo_titulos')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.consecutivo_certificados"
              v-model="campus.consecutivo_certificados"
              @click:append="editarCampus('consecutivo_certificados')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              v-if="campus.entidad_federativa.nombre === 'BAJA CALIFORNIA'"
              :label="labels.sostenimiento"
              v-model="campus.sostenimiento"
              @click:append="editarCampus('sostenimiento')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      loading: false,

      campus: {
        entidad_federativa: {}
      }
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'campus' })
        }  
      }
    },

    mounted() {
      this.getCampus(this.$route.params.id)
    },

    methods: {
      getCampus(id) {
        this.loading = true
        axios
          .get(api.path('campus.single', { id: id } ))
          .then(res => {
            this.campus = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
            this.loading = false
          })
      },

      editarCampus(campo) {
        this.$router.push({ name: "campus-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
